// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import { initializeApp } from 'firebase/app';
import { isSupported } from 'firebase/messaging/sw';
import React, { useContext, useState } from 'react';
const PushContext = React.createContext({});

const PushProvider = ({ children }) => {
  const [isPushSupported, setPushSupported] = useState(false);
  const [token, setToken] = useState();
  const [hasNotificationPermission, setNotificationPermission] = useState();
  const providerValue = {
    isSupported,
    token,
    hasNotificationPermission
  };
  isSupported()
    .catch(() => false)
    .then(setPushSupported);
  useEffect(() => {
    if (
      isPushSupported &&
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      window.workbox !== undefined
    ) {
      window.Notification.requestPermission((permission) =>
        setNotificationPermission(permission === 'granted')
      );
      navigator.serviceWorker.ready.then(async (reg) => {
        const app = initializeApp(firebaseOptions);
        const messaging = getMessaging(app);
        const token = await getToken(messaging, {
          serviceWorkerRegistration: reg
        });
        setToken(token);
      });
    }
  }, [isPushSupported]);

  return (
    <PushContext.Provider value={providerValue}>
      {children}
    </PushContext.Provider>
  );
};

const usePush = () => useContext(PushContext);

export { PushProvider, usePush };
